module.exports = __webpack_public_path__ + "static/media/pos.608df311.png";